<template>
  <Form
    v-model:firstName="customer.firstName"
    v-model:lastName="customer.lastName"
    v-model:email="customer.email"
    v-model:phone="customer.mobilePhone"
    v-model:address="customer.address"
    v-model:zipcode="customer.zipcode"
    v-model:city="customer.city"
    v-model:dateOfBirth="customer.dateOfBirth"
    v-model:personalRegistrationNumber="customer.personalRegistrationNumber"
    v-model:insuranceProvider="customer.insuranceProvider"
    :requireAddress="requireAddress"
    :requireMedicalData="requireMedicalData"
  />
</template>

<script
  setup
  lang="ts"
>
import Form from '@/modals/create-customer/Form.vue';

withDefaults(
  defineProps<{
    customer: any;
    requireAddress?: boolean;
    requireMedicalData?: boolean;
  }>(),
  {
    requireAddress: false,
    requireMedicalData: false,
  },
);
</script>
